import React, { useEffect, useState } from "react";
import "./RegistrationForm.scss";
import CustomTextBox from "../customTextBox/CustomTextBox";
import CustomButton from "../customButton/CustomButton";
import CustomGoBack from "../customGoBack/CustomGoBack";
import { validateEmail } from "../login-form/LoginForm";
import { ToastDisplayer } from "../toastDisplay/ToastDisplayer";
import {
  checkEmailExistsAndRole,
  generateOtpWithAction,
} from "../../api/forgotPwdApi";
import { LoadPanel, TextBox } from "devextreme-react";
import { generateOtpForRegister } from "../../api/registerUserApi";

export default function RegistrationForm({ onContinue, onResetPwdGoBack }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  // const [userRole, setUserRole] = useState("agent");

  const handleContinue = async () => {
    try {
      const trimmedEmail = email.trim();

      if (!trimmedEmail) {
        return ToastDisplayer("error", "Email address cannot be empty.");
      }

      if (!validateEmail(trimmedEmail)) {
        return ToastDisplayer("error", "Please enter a valid email address.");
      }

      setLoading(true);

      const otpResult = await generateOtpForRegister(trimmedEmail);

      if (otpResult.status === 200) {
        ToastDisplayer("success", otpResult.data.message);
        onContinue(trimmedEmail, "register");
      } else {
        ToastDisplayer("error", "OTP generation failed");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.error || "Something went wrong",
      );
    } finally {
      setLoading(false);
    }
  };
  //To Add Enter key functionality!
  const handleKeyDown = (e, name) => {
    e.stopPropagation();
    if (e.key === "Enter") {
      handleContinue();
    }
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}
      <CustomGoBack onGoBack={onResetPwdGoBack} />

      <div className="resetHeader">Register New User</div>
      <div className="resetText">Type your email address to get an OTP</div>

      <div className="MyTextBox">
        <div className="fieldsMain">
          {/* <div className="roleSelection">
            <label className="TextBoxLabel">
              Select Role <span className="requiredClass">*</span>
            </label>

            <div className="roleRadioGroup">
              <label>
                <input
                  type="radio"
                  name="userRole"
                  value="agent"
                  checked={userRole === "agent"}
                  onChange={(e) => setUserRole(e.target.value)}
                />
                Agent
              </label>

              <label>
                <input
                  type="radio"
                  name="userRole"
                  value="client"
                  checked={userRole === "client"}
                  onChange={(e) => setUserRole(e.target.value)}
                />
                Client
              </label>

              <label>
                <input
                  type="radio"
                  name="userRole"
                  value="clientuser"
                  checked={userRole === "clientuser"}
                  onChange={(e) => setUserRole(e.target.value)}
                />
                Client User
              </label>
            </div>
          </div> */}
          <label className="TextBoxLabel" htmlFor="email">
            Email Address <span className="requiredClass">*</span>
          </label>
          <div className="TextBoxWrapper">
            <TextBox
              placeholder="Type your Email address"
              value={email}
              onValueChange={(e) => setEmail(e)}
              type="email"
              stylingMode="outlined"
              className="TextBoxMain"
              valueChangeEvent="keyup"
              onKeyDown={(e) => handleKeyDown(e.event, "email")}
            />
          </div>
        </div>
      </div>

      <div className="mySpace">
        <CustomButton text="Continue" onClick={handleContinue} />
      </div>
    </>
  );
}
